var $fbfe3084f779dd7b$exports = {};
$fbfe3084f779dd7b$exports = {
    "info": `Informacije`,
    "negative": `Napaka`,
    "notice": `Opozorilo`,
    "positive": `Uspe\u{161}no`
};


export {$fbfe3084f779dd7b$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
